import React, { useState, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import CreationApproval from "./tab/CreationApproval";
import DeletionApproval from "./tab/DeletionApproval";

const AssetApproval = () => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("creation");

  const categories = useMemo(() => [
    { id: "creation", name: "Creation Approval" },
    { id: "deletion", name: "Deletion Approval" },
  ], []);

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam) {
      const validIds = categories.map(c => c.id);
      if (validIds.includes(tabParam.toLowerCase())) {
        setActiveTab(tabParam.toLowerCase());
      }
    }
  }, [searchParams, categories]);

  const currentCategoryName = categories.find(c => c.id === activeTab)?.name || "Asset Approvals";

  return (
    <div className="flex flex-col h-screen bg-background">
      {/* Header */}
      <div className="border-b bg-card">
        <div className="px-6 py-4">
          <h1 className="text-2xl font-semibold tracking-tight">
            {currentCategoryName}
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Review and approve or decline asset {activeTab} requests
          </p>
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-auto">
        {activeTab === "creation" && <CreationApproval />}
        {activeTab === "deletion" && <DeletionApproval />}
      </div>
    </div>
  );
};

export default AssetApproval;
